import Joyride, { type CallBackProps } from "react-joyride";
import type { Step } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";

type MeetingTourProps = {
  steps: Step[];
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function MeetingTour({ steps, run, onCallback }: MeetingTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({
      status: data.status,
      type: data.type,
      index: data.index,
      action: data.action,
    });
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}
